import React, { ReactNode } from "react";

export interface SquaresGridRowProps {
    children: ReactNode;
}

export const SquaresGridRow = (props: SquaresGridRowProps) => {
    return <tr>{props.children}</tr>;
};
